// extracted by mini-css-extract-plugin
export default {"title":"AuthSubmitButton_title__qR2oQ","submitButton":"AuthSubmitButton_submitButton__1969V"};